<template>
  <div>
    <Header />

    <div class="about">
      <div class="about-top breadcrumbs d-flex align-items-center">
        <div
          class="container position-relative d-flex flex-column align-items-center"
        >
          <h2>{{ $t("about.About_us") }}</h2>
        </div>
      </div>
      <!-- <img src="../../../assets/images/info/about-us.jpg" alt="" /> -->
    </div>
    <b-container>
      <b-row class="about-block1-img">
        <b-col sm="12" md="4">
          <img
            class="blockchainImg"
            src="../../../assets/images/info/aboutUs.png"
            alt=""
          />
        </b-col>
        <b-col sm="12" md="8" class="about-block1-col">
          <div class="about-block1-info">
            <ul>
              <li>
                <i class="fa-solid fa-circle-check" />
                {{ $t("about.About_us_p1") }}
              </li>
              <li>
                <i class="fa-solid fa-circle-check" />
                {{ $t("about.About_us_p2") }}
              </li>
              <li>
                <i class="fa-solid fa-circle-check" />
                {{ $t("about.About_us_p3") }}
              </li>
              <li>
                <i class="fa-solid fa-circle-check" />
                {{ $t("about.About_us_p4") }}
              </li>
              <li>
                <i class="fa-solid fa-circle-check" />
                {{ $t("about.About_us_p5") }}
              </li>
              <li>
                <i class="fa-solid fa-circle-check" />
                {{ $t("about.About_us_p6") }}
              </li>
            </ul>
          </div>
        </b-col>
      </b-row>
      <b-row class="about-block1-img">
        <b-col sm="12" md="8" class="about-block1-col">
          <div class="about-block1-info">
            <div
              class="container position-relative d-flex flex-column align-items-center"
            >
              <h1 class="about-mission">{{ $t("about.mission") }}</h1>
            </div>
            <ul>
              <li>
                <i class="fa-solid fa-circle-check" />
                {{ $t("about.mission_p1") }}
              </li>
              <li>
                <i class="fa-solid fa-circle-check" />
                {{ $t("about.mission_p2") }}
              </li>
              <li>
                <i class="fa-solid fa-circle-check" />
                {{ $t("about.mission_p3") }}
              </li>
            </ul>
          </div>
        </b-col>
        <b-col sm="12" md="4">
          <img
            class="blockchainImg2"
            src="../../../assets/images/info/MISSION.png"
            alt=""
          />
        </b-col>
      </b-row>
      <b-row class="about-block1-img mb-5">
        <b-col sm="12" md="4">
          <img
            class="blockchainImg3"
            src="../../../assets/images/info/VISION.png"
            alt=""
          />
        </b-col>
        <b-col sm="12" md="8" class="about-block1-col">
          <div class="about-block1-info">
            <div
              class="container position-relative d-flex flex-column align-items-center"
            >
              <h1 class="about-mission">{{ $t("about.vision") }}</h1>
            </div>
            <ul>
              <li>
                <i class="fa-solid fa-circle-check" />
                {{ $t("about.vision_p1") }}
              </li>
              <li>
                <i class="fa-solid fa-circle-check" />
                {{ $t("about.vision_p2") }}
              </li>
              <li>
                <i class="fa-solid fa-circle-check" />
                {{ $t("about.vision_p3") }}
              </li>
            </ul>
          </div>
        </b-col>
      </b-row>
    </b-container>
    <Footer />
  </div>
</template>

<script>
import Header from "@/layouts/landpage/HeaderHome.vue";
import Footer from "@/layouts/landpage/Footer.vue";
import { ValidationProvider, ValidationObserver } from "vee-validate";

import {
  BFormInput,
  BFormGroup,
  BInputGroup,
  BInputGroupPrepend,
  BForm,
  BContainer,
  BRow,
  BCol,
  BCard,
  BButton,
  BFormDatepicker,
  BFormTextarea,
  BMedia,
  BImg,
  BCardText,
} from "bootstrap-vue";
import { required, email } from "@validations";

export default {
  components: {
    Header,
    Footer,
    ValidationProvider,
    ValidationObserver,
    BFormInput,
    BFormGroup,
    BInputGroup,
    BInputGroupPrepend,
    BContainer,
    BForm,
    BRow,
    BCard,
    BCol,
    BButton,
    BFormDatepicker,
    BFormTextarea,
    BMedia,
    BImg,
    BCardText,
  },
  data() {
    return {
      name: "",
      email: "",
      message: "",
    };
  },
};
</script>

<style scoped>
.about {
  /* margin-top: 110px; */
  margin-bottom: 75px;

  /* padding: 40px 40px 128px 40px; */
}
.about-block1-col {
  margin: auto;
}

.about .contact-top {
  height: 290px;
}
.about .about-block1-img img {
  height: 300px;
}

.about-mission {
  font-size: x-large;
  color: #366ce3;
}
.about-block1-img {
  margin-top: 60px;
}

.about .about-block1-info {
  margin-top: 50px;
}
.about .about-block1-info h2 {
  font-size: 25px;
  color: #005692;
}
.about .about-block1-info p {
  font-size: 16px;
  font-weight: 500;
  text-align: justify;
}

@media (max-width: 550px) {
  .about .about-top img {
    width: 330px;
  }
  .about .about-block1-img img {
    display: none;
  }
  .about .about-block1-info p {
    text-align: start;
  }
}

.about-block2 {
  margin-top: 60px;
}
.about-block2 h2 {
  text-align: center;
  font-weight: 500;
  color: #005692;
  margin-bottom: 45px;
}

[dir] .card-img,
[dir] .card-img-top {
  height: 250px;
}
[dir] .card .card-title {
  color: #366ce3;
  font-weight: 500;
  cursor: pointer;
}
[dir] .card-text:last-child {
  font-size: 14px;
}
@media (max-width: 550px) {
  .block-cvshot .card {
    position: relative;
    display: flex;
    min-width: 0;
    word-wrap: break-word;
    align-content: flex-start;
    flex-direction: column-reverse;
    flex-wrap: wrap;
  }
  .block-cvshot img {
    margin: 0 7px;
    width: 350px;
  }
}
@media (min-width: 920px) {
  .block-cvshot .card .card-title {
    color: #366ce3;
    font-weight: 600;
    font-size: 22px;
  }
  .block-cvshot .card-text:last-child {
    font-size: 15px;
  }
}
@media (min-width: 920px) {
  [dir="ltr"] .card-body {
    padding: 1.5rem;
    min-height: 350px;
  }
  .cvshots-card .card-body {
    min-height: auto;
    margin: auto;
  }
}
.card-text:last-child {
  font-size: 16px;
  font-weight: 500;
}

.about-top {
  background-image: url(../../../assets/images/info/about-header.jpg);
  padding: 140px 0 60px 0;
  min-height: 30vh;
  position: relative;
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
}
.breadcrumbs:before {
  content: "";
  background-color: rgba(27, 47, 69, 0.7);
  position: absolute;
  inset: 0;
}
.breadcrumbs h2 {
  font-size: 56px;
  font-weight: 500;
  color: #fff;
  font-family: var(--font-secondary);
}

.about-block1-info ul {
  list-style: none;
  padding: 0;
}

.about-block1-info ul li {
  padding: 0 0 15px 26px;
  position: relative;
  font-size: 15px;
  font-weight: 500;
}
.about-block1-info ul li i {
  font-size: 16px;
  color: #56b8e6;
}
.blockchainImg {
  width: 450px;
}
.blockchainImg2 {
  width: 400px;
  margin: auto;
  height: auto;
}
.blockchainImg3 {
  width: 400px;
  margin: auto;
  height: auto;
}
@media (max-width: 550px) {
  .blockchainImg,
  .blockchainImg2,
  .blockchainImg3 {
    display: none;
    /* width: 400px; */
  }

  .about-block2 h2 {
    font-size: 18px;
  }
}
</style>
<style scoped>
@media (min-width: 920px) {
  [dir="rtl"] .card-body {
    padding: 1.5rem;
    min-height: 250px;
  }
}
</style>
